import _has from "lodash/has";
import _each from "lodash/each";
import _isArray from "lodash/isArray";
import _isString from "lodash/isString";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.slice.js";

/**
 *  `pickWildcards(object, path)`
 *  is a method that will return all items matching a `wildcard` path
 *    - e.g. 'foo.*.bar' would find all values for all keys names 'bar'
              in objects in list under key `foo`
 *  Using this method is very similar to lodash `pick(object, path)`,
 *  with one very notable difference:
 *  - returns object with all matched values, keyed by full path in object
 *    - these keys are string paths compatible with lodash `set` and `get`
 * */
export default function pickWildcards(obj, paths) {
  var output = {};

  if (_isString(paths)) {
    return mapWildcardValues(obj, paths, output); // eslint-disable-line no-use-before-define
  }

  if (_isArray(paths)) {
    _each(paths, function (path) {
      return mapWildcardValues(obj, path, output);
    }); // eslint-disable-line no-use-before-define


    return output;
  }

  throw new Error('pickWildcards: second argument `paths` must be a string or array of strings');
}
export function mapWildcardValues(obj, path) {
  var output = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (_isString(path)) return mapWildcardValues(obj, path.split('.'), output);
  recursivelyMapWildcardValues(obj, path, output); // eslint-disable-line no-use-before-define

  return output;
}

function recursivelyMapWildcardValues(obj, path, output, keyPath) {
  var currentPath = path[0]; // check if recursion has made it to the bottom

  if (currentPath === undefined) {
    // set the full path key in output to this obj value
    output[keyPath] = obj; // eslint-disable-line no-param-reassign

    return;
  } // prepare prefix for next keyPath


  var keyPathPrefix = keyPath !== undefined && keyPath.length > 0 ? "".concat(keyPath, ".") : ''; // check for wildcard

  if (currentPath === '*') {
    // loop over and recurse into all items in the list
    var pathAfterWildcard = path.slice(1); // eslint-disable-next-line lodash/collection-method-value

    return _each(obj, function (item, i) {
      return recursivelyMapWildcardValues(item, pathAfterWildcard, output, "".concat(keyPathPrefix).concat(i));
    });
  } // get the next object in the path and recurse


  if (_has(obj, currentPath)) {
    return recursivelyMapWildcardValues(obj[currentPath], path.slice(1), output, "".concat(keyPathPrefix).concat(currentPath));
  } // nothing more to set

}